export enum TeleworkerState {
  Login = 'login',
  Logout = 'logout',
  News = 'news',
  Reports = 'reports',
  Timesheets = 'timesheets',
  ContactDetails = 'contact-details',
  Scheduling = 'scheduling',
  Training = 'training',
  Work = 'work',
  CampaignSelected = 'campaign-selected',
  CampaignLaunched = 'campaign-launched',
  AwaitingNailIn = 'awaiting-nail-in',
  Preview = 'preview',
  InboundWaiting = 'inbound-waiting',
  InboundConnected = 'inbound-connected',
  OutboundWaiting = 'outbound-waiting',
  OutboundConnected = 'outbound-connected',
  CallDialling = 'call-dialling',
  CallDisconnected = 'call-disconnected',
  DiallerLogin = 'dialler-login',
  DiallerLogout = 'dialler-logout',
  DiallerLoggedIn = 'dialler-loggedin',
  AvailableIB = 'available-ib',
  AvailableOB = 'available-ob',
  UnavailableIB = 'unavailable-ib',
  UnavailableOB = 'unavailable-ob',
  SIPNailIn = 'sip-nailin',
  WrapIB = 'inbound-wrap',
  WrapOB = 'outbound-wrap',
  HoldIB = 'inbound-hold',
  HoldOB = 'outbound-hold',
  Unavailable = 'unavailable',
  TransferIB = 'inbound-transfer',
  TransferOB = 'outbound-transfer',
  EmptyQueue = 'outbound-queueempty',
  UpdateDetails = 'update-details',
  Standby = 'standby',
  IBMissedCall = 'ib-missed-call',
  Ringing = 'ringing',
  Voicemail = 'voicemail',
  BlendedPreview = 'blended-preview',
  Refresh = 'refresh',
  IBTransferOnly = 'inbound-transfer-only',
  Idle = 'idle',
  UAT = 'UAT',
  Tasks = 'tasks',
}
